import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from '../../i18n/FormattedMessage';
import SearchBar from '../SearchBar';
import { getVisibleReportCategories } from '../../utils/Constants';
import { reportCat } from '../../redux/actions/reportCategory';

/**
 * this is used to set initial filter alues set to false
 * @param {string} filtersLabels - report categories labels
 */
const populateInitialValues = (filtersLabels) => {
  const filters = {};
  const values = Object.values(filtersLabels);
  for (let reportIndex = 0; reportIndex < values.length; reportIndex += 1) {
    Object.assign(filters, { [values[reportIndex]]: false });
  }
  return filters;
};
const buildReportFilters = (accountCategories) => ({
  ...populateInitialValues(getVisibleReportCategories(accountCategories)),
});

export class CompleteReportHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reportFilters: buildReportFilters(props.accountReportCategories),
      expandedIndex: -1,
    };
  }

  componentDidMount() {
    // Ensure the account's categories are loaded so restricted categories can
    // be filtered even if the parent view did not fetch them.
    const { accountReportCategories, fetchReportCategories } = this.props;
    const isEmpty =
      !accountReportCategories ||
      Object.keys(accountReportCategories).length === 0;
    if (fetchReportCategories && isEmpty) {
      fetchReportCategories();
    }
  }

  componentDidUpdate(prevProps) {
    // Rebuild the filter list once the account's categories arrive so that
    // restricted categories the account lacks (e.g. Evacuation) are excluded.
    if (
      prevProps.accountReportCategories !== this.props.accountReportCategories
    ) {
      this.setState({
        reportFilters: buildReportFilters(this.props.accountReportCategories),
      });
    }
  }

  render() {
    return (
      <div data-testid="taskheader">
        <div
          data-testid="searchbar"
          className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center top-search-field"
        >
          <h1>
            <FormattedMessage
              id={this.props.name || ' '}
              defaultMessage={this.props.name || ' '}
            />
          </h1>
          <SearchBar
            onTextChange={(e) => {
              if (e === '') {
                this.props.handleSearch('');
              } else {
                this.props.setSearchText(e.target.value);
              }
            }}
            searchValue={this.props.searchText}
            isCrossVisible={this.props.isCrossVisible}
            onSearchPress={this.props.handleSearch}
          />
        </div>
      </div>
    );
  }
}
CompleteReportHeader.propTypes = {
  isCrossVisible: PropTypes.bool,
  setDatePeriod: PropTypes.func,
  setFilters: PropTypes.func,
  setReportType: PropTypes.func,
  filter: PropTypes.array,
  handleSearch: PropTypes.func,
  reportType: PropTypes.string,
  name: PropTypes.string,
  setSearchText: PropTypes.func,
  searchText: PropTypes.string,
  accountReportCategories: PropTypes.object,
  fetchReportCategories: PropTypes.func,
};

const mapStateToProps = (state) => ({
  accountReportCategories: state.reportCategory.reportData,
});

export default connect(mapStateToProps, { fetchReportCategories: reportCat })(
  CompleteReportHeader
);
